import { Layout } from 'antd';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../service/api';
import * as S from './styles';
import ComboBox from '../../components/ComboBox/ComboBox';

const { Header, Content } = Layout;

export type User = {
  conciliador: string;
  email: string;
  extensaoLogo: string | null;
  id: number;
  img: string;
  nomeArquivoLogo: string | null;
  password: string;
  powerBi: string;
  tipoDeUsuario: number;
};

const Home: React.FC = () => {
  // Admin abre /acessar/:id (id na URL). Cliente entra por /painel (sem id na URL) e o id
  // vem do próprio cadastro salvo no login — assim o número não fica exposto na barra.
  const { id: idParam } = useParams<{ id: string }>();
  const id = idParam || JSON.parse(localStorage.getItem('cliente') || '{}')?.id;
  const [currentUser, setCurrentUser] = useState<User>();
  const [selectedView, setSelectedView] = useState<string>('dashboard'); // Valor padrão ou inicialização

  useEffect(() => {
    // Ao ENTRAR no painel (novo cliente / nova abertura), zera os filtros compartilhados para o
    // default: periodo volta aos ultimos 30 dias e empresa volta a "Todos". As 4 telas internas leem
    // o localStorage ao montar, entao abrem no default; durante a navegacao entre elas o filtro segue
    // compartilhado. So reseta numa nova abertura do painel (nao a cada troca de tela).
    try {
      localStorage.removeItem('painel.periodo')
      localStorage.removeItem('painel.empresas')
    } catch {
      /* storage bloqueado -> ignora */
    }
  }, [])

  useEffect(() => {
    async function GetCliente() {
      await api.get(`api/Cliente/${id}`).then(function (response) {
        console.log(response);
        setCurrentUser(response.data);
      })
        .catch(function (error) {
          console.log(error);
        });
    };
    GetCliente();
  }, [id]);

  // Simular mudança de seleção para o propósito deste exemplo
  useEffect(() => {
    if (currentUser) {
      // Defina a seleção inicial se necessário
      // Exemplo: setSelectedView('dashboard');
    }
  }, [currentUser]);

  const user: any = localStorage.getItem('user');

  // Só admin (tipoDeUsuario === 1) vê o menu "MAIS ACESSOS"; cliente comum não.
  const isAdmin = JSON.parse(localStorage.getItem('user') || 'null') === 1;

  // grupo do cliente para escopar o dashboard interno (mesma origem do ComboBox)
  const clienteLocal: any = JSON.parse(localStorage.getItem('cliente') || '{}')
  const grupoDoCliente: string =
    (currentUser as any)?.nomeDoGrupo || clienteLocal?.nomeDoGrupo || ''

  return (
    <Layout className="layout" style={{ height: '100vh', overflow: 'hidden' }}>
      {currentUser && (
        <>
          <Header
            style={{
              backgroundColor: "#f0f2f5",
              boxShadow: "0 4px 8px -3px rgba(0, 0, 0, 0.15)",
              position: "relative",
              zIndex: 10,
              display: 'flex',
              height: "auto",
              maxHeight: "60px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <S.ContainerImage>
              <img src={"data:image/png;base64," + currentUser?.img} alt="logo" />
            </S.ContainerImage>
            <S.ContainerWord>
              Análise de Dados
            </S.ContainerWord>
            {isAdmin && (
              <S.MenuContainer>
                <ComboBox currentUser={currentUser} />
              </S.MenuContainer>
            )}

          </Header>
          <Content style={{ backgroundColor: "white", flex: 1, minHeight: 0, overflow: "hidden" }}>
            <S.SiteLayoutContent>
              {currentUser && selectedView === 'dashboard' && ( // Renderiza o dashboard interno filtrado pelo grupo do cliente
                <S.Iframe
                  title="Dashboard de Vendas"
                  src={`/dashboard?grupo=${encodeURIComponent(grupoDoCliente)}`}
                  frameBorder="0"
                  allowFullScreen
                />
              )}
              {currentUser && selectedView === 'lista' && ( // Renderiza o iframe da lista
                <S.Iframe
                  title="listaPortalAdministradoras"
                  src={'/listaPortalAdministradoras'}
                  frameBorder="0"
                  allowFullScreen
                />
              )}
            </S.SiteLayoutContent>
          </Content>
        </>
      )}
    </Layout>
  );
}

export default Home;